import type { DeviceConfigurationApi } from '@model/DeviceConfiguration';
import type { PatientHubListItem, PatientHubListRow } from '../types';
import {
  getLatestActivePatientSession,
  toPatientSessionList,
} from './sessions';

export const buildPatientHubListRows = (
  patients: PatientHubListItem[],
  sessions: DeviceConfigurationApi[]
): PatientHubListRow[] =>
  patients.map(patient => ({
    ...patient,
    latestActiveSession: getLatestActivePatientSession(
      toPatientSessionList(sessions, patient.id)
    ),
  }));
